import {createContext, type PropsWithChildren, use, useMemo} from 'react'
import type {IUpdatePreviews} from '../types'

export const UpdatePreviewsContext = createContext<IUpdatePreviews | undefined>(undefined)

export function UpdatePreviewsProvider({children, togglePreview, setRulesetName}: PropsWithChildren<IUpdatePreviews>) {
  const value = useMemo(() => ({togglePreview, setRulesetName}), [togglePreview, setRulesetName])

  return <UpdatePreviewsContext value={value}>{children}</UpdatePreviewsContext>
}

export function useUpdatePreviews() {
  const context = use(UpdatePreviewsContext)
  if (!context) {
    throw new Error('useUpdatePreviews must be used within a UpdatePreviewsProvider')
  }
  return context
}
